import React from "react";
import { useTranslation } from "react-i18next";
import { CheckoutStep } from "../checkoutSlice";
import Icon from "../../../../common/components/Icon/Icon";

interface CheckoutProgressProps {
  currentStep: CheckoutStep;
}

const CheckoutProgress: React.FC<CheckoutProgressProps> = ({ currentStep }) => {
  const { t } = useTranslation();

  const steps: { key: CheckoutStep; label: string; icon: string }[] = [
    {
      key: "billing",
      label: t("checkoutProgress.billing", "Billing"),
      icon: "receipt-text", // Represents personal/billing info
    },
    {
      key: "shipping",
      label: t("checkoutProgress.shipping", "Shipping"),
      icon: "truck", // Represents delivery
    },
    {
      key: "payment",
      label: t("checkoutProgress.payment", "Payment"),
      icon: "credit-card", // Represents payment
    },
  ];

  // Helper to determine index for completion logic
  const stepKeys = steps.map((s) => s.key);
  const currentIndex = stepKeys.indexOf(currentStep);

  return (
    <div className="checkout-progress">
      <div className="checkout-progress__track">
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isActive = index === currentIndex;

          let modifierClass = "";
          if (isCompleted) modifierClass = "is-completed";
          else if (isActive) modifierClass = "is-active";

          return (
            <div
              key={step.key}
              className={`checkout-progress__step ${modifierClass}`}
            >
              {/* Icon Circle */}
              <div className="checkout-progress__icon-wrapper">
                {isCompleted ? (
                  <Icon iconName="check" className="icon--stroke-thickest" />
                ) : (
                  <Icon iconName={step.icon} className="icon--stroke-thicker" />
                )}
              </div>

              {/* Label */}
              <span className="checkout-progress__label">{step.label}</span>

              {/* Connecting Line (Visual only, hidden on last item via CSS) */}
              <div className="checkout-progress__line"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckoutProgress;
